<template>
    <div class="container flex pb-24 pl-6 pr-6 lg1024:pl-0 lg1024:pr-0">
        <div class="w-full lg1024:border-r lg1024:border-themeGray pt-8">
            <div class="font-bold text-2xl">{{getTitleMessage()}}</div>
            <div v-if="rendered">
                <PostsGrid :layout="'rows'" :posts="posts" v-if="posts.length"/>
                <div class="flex justify-center relative mt-20" v-else>{{getErrorMessage()}}</div>
            </div>
            <div class="min-h-screen flex justify-center relative" v-else>
                <Loader />
            </div>
        </div>
        <SidebarWidget :position="'right'" v-if="rendered" class="hidden lg1024:flex">
        </SidebarWidget>
    </div>
</template>

<script>
  import PostsGrid from "../components/PostsGrid.vue";
  import SidebarWidget from "../components/SidebarWidget.vue";
  import Loader from "../components/Loader.vue";
  export default {
    name: 'PressCenter',
    components: {
      SidebarWidget,
      PostsGrid,
      Loader
    },
    data() {
      return {
        posts: [],
        rendered: false
      }
    },
    methods: {
      getTitleMessage() {
        return this.$store.getters.getTranslation("events");
      },
      getErrorMessage() {
        return this.$store.getters.getTranslation("no_posts_in_category");
      },
      getPosts() {
        this.posts = this.$store.getters.filterPostsByCategory("174");
        return this.posts.length;
      }
    },
    mounted() {
      document.querySelector('title').innerText = 'Coral News'
      document.querySelector('meta[name="description"]').innerText = ''
      this.$store.commit("changeCurrentUrl", "События");
      if(!this.getPosts()) {
        return this.$store.dispatch('GET_POSTS').then(() => {
          this.getPosts();
          this.rendered = true;
        })
      } else {
        this.rendered = true;
      }
    }
  }
</script>

<style scoped>

</style>
